import $ from 'jquery';
import constants from 'Constants.js';
import Immutable from 'immutable';

import util from 'util/Util.js';
import { View } from 'backbone';

import fileAttachmentTemplate from 'properties/main/fileattachment_button_position.ejs';
import webSignatureTemplate from 'properties/main/websignature_button_position.ejs';

import mobileSyncService from "../../../service/mobile/MobileSyncService";

class MainButtonPositionView extends View {

    initialize( opts ) {
        this.options = opts || {};
        this.tagName = 'div';
        this.id = opts.el;

        this.events = {
            'change input[type=checkbox]' : 'updateCheckboxAttributes'
        };

        

        if (this.model.get('factoryKey') === 'control_websignature') {
            if (util.isTrue(this.model.get('buttonPositionAbove'))) {
                this.model.set('buttonPosition', "checked", {silent: true});
            } else {
                this.model.set('buttonPosition', "unchecked", {silent: true});
            }
            this.template = webSignatureTemplate;
        }

        if (this.model.get('factoryKey') === 'control_file_attachment') {
            if (util.isTrue(this.model.get('buttonPositionLeft'))) {
                this.model.set('buttonLeft', "checked", {silent: true});
                //this.model.set('position', "left", {silent: true});
            } else {
                this.model.set('buttonLeft', "unchecked", {silent: true});
                //this.model.set('position', "right", {silent: true});
            }

            this.template = fileAttachmentTemplate;
        }

        //this.listenTo(this.model, 'change', this.render);
        return this;
    }

    updateCheckboxAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.checked;

        if (this.model.get('factoryKey') === 'control_websignature') {
            if (propVal) {
                this.model.set('buttonPosition', 'checked');
                //this.model.set('position','top');
            } else {
                this.model.set('buttonPosition', 'unchecked');
                //this.model.set('position','bottom');
            }


            this.model.set('buttonPositionAbove', propVal);

            mobileSyncService.synchronizeMobileForm(this.model, 'control_websignature', {key: 'buttonPosition', val: this.model.get('buttonPosition') });
            mobileSyncService.synchronizeMobileForm(this.model, 'control_websignature', {key: 'buttonPositionAbove', val: this.model.get('buttonPositionAbove')});
        }

        if (this.model.get('factoryKey') === 'control_file_attachment') {
            if (propVal) {
                //this.model.set('position', "left", {silent: true});
                this.model.set('buttonLeft', 'checked', {silent: true});
            } else {
                //this.model.set('position', "right", {silent: true});
                this.model.set('buttonLeft', 'unchecked', {silent: true});
            }

            this.model.set('buttonPositionLeft', propVal);

            mobileSyncService.synchronizeMobileForm(this.model, 'control_file_attachment', {key: 'buttonLeft', val: this.model.get('buttonLeft')} );
            mobileSyncService.synchronizeMobileForm(this.model, 'control_file_attachment', {key: 'buttonPositionLeft', val: this.model.get('buttonPositionLeft')});
        }

    }

    render() {
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        this.delegateEvents();
        return this;
    }

}

export default MainButtonPositionView;
